import { Component, inject, OnInit } from "@angular/core";
import { BpModalCanDismiss } from "@models";
import { CustomModal } from "@modules/core/components/base-modals";
import { ModalService } from "@core-services/modal.service";
import { BehaviorSubject, take } from "rxjs";
import { AntiPhishingBlockType } from "@modules/shared/modals/anti-phishing-code-modal/interfaces";
import { AntiPhishingCodeModalService } from "../../services/anti-phishing-code-modal.service";
import { SegmentService } from "@main-services/segment.service";
import { KycService } from "@modules/kyc/services/kyc.service";
import { RudderstackService } from "@main-services/rudderstack.service";

@Component({
	templateUrl: "./anti-phishing-force-modal.component.html",
	styleUrls: ["./anti-phishing-force-modal.component.scss"],
	standalone: false
})
export class AntiPhishingForceModalComponent extends CustomModal implements BpModalCanDismiss, OnInit {
	private readonly kycService = inject(KycService);
	private readonly segmentService = inject(SegmentService);
	private readonly rudderstackService = inject(RudderstackService);
	private readonly apcModalService = inject(AntiPhishingCodeModalService);
	public data: {
		apcBlockType: AntiPhishingBlockType;
	};

	public isSkippable$: BehaviorSubject<boolean> = new BehaviorSubject(false);

	constructor(protected modalService: ModalService) {
		super();
	}

	public ngOnInit(): void {
		const isSkippable = this.isSkippable();
		let skippableInitEventName = "Home APC Full Blocking Bottom Sheet Screen Viewed ";
		if (isSkippable) {
			skippableInitEventName = "Home APC Half Bottom Sheet Blocking Screen Viewed";
		}
		this.segmentService.track({
			name: skippableInitEventName
		});
		this.rudderstackService.track({
			name: skippableInitEventName
		});

		this.isSkippable$.next(isSkippable);
	}

	public isSkippable(): boolean {
		return this.data.apcBlockType === AntiPhishingBlockType.HALF;
	}

	public modalCanDismiss(): boolean {
		return true;
	}

	onClickSetup(): void {
		this.segmentService.track({
			name: "APC Set Up Code Tapped",
			properties: {
				screen_it_happened_on: this.isSkippable()
					? "full_bottom_sheet_blocking_screen"
					: "half_bottom_sheet_blocking_screen"
			}
		});
		this.rudderstackService.track({
			name: "APC Set Up Code Tapped",
			properties: {
				screen_it_happened_on: this.isSkippable()
					? "full_bottom_sheet_blocking_screen"
					: "half_bottom_sheet_blocking_screen"
			}
		});

		this.apcModalService.openAntiPhishingSetupModal("", this.data.apcBlockType === AntiPhishingBlockType.FULL);
		this.apcModalService.antiPhishingSetupModal.onDismiss.pipe(take(1)).subscribe(() => {
			if (!this.apcModalService.currentAntiPhishingCode) {
				this.apcModalService.openAntiPhishingForceModal(this.data.apcBlockType);
			}
		});
		this.modalService.getCurrentModal().dismiss();
	}

	onClickSkip(): void {
		this.apcModalService.skipApcSetup();
		this.kycService.checkKycModal();
		this.modalService.getCurrentModal().dismiss();

		this.segmentService.track({
			name: "Home APC Half Bottom Sheet Blocking Screen Skip Clicked"
		});
		this.rudderstackService.track({
			name: "Home APC Half Bottom Sheet Blocking Screen Skip Clicked"
		});
	}
}
